import { render, staticRenderFns } from "./dataCreatForm.vue?vue&type=template&id=0356adf5&"
import script from "./dataCreatForm.vue?vue&type=script&lang=js&"
export * from "./dataCreatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dataCreatForm.vue"
export default component.exports